import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

interface Friend {
  id?: string;
  name: string;
  imageUrl: string;
  relationship: string;
}

export default function FriendsOfWattlenest() {
  const [friends, setFriends] = useState<Friend[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch friends from Firestore
  useEffect(() => {
    const fetchFriends = async () => {
      setIsLoading(true);
      try {
        const friendsCollection = collection(db, "friends");
        const friendsSnapshot = await getDocs(friendsCollection);
        const friendsList = friendsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as Friend[];
        setFriends(friendsList);
      } catch (error) {
        console.error("Error fetching friends:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFriends();
  }, []);

  return (
    <div className="mx-auto max-w-7xlpy-16">
      <div className="mx-auto max-w-2xl lg:text-center mb-12">
        <h2 className="text-base font-semibold leading-7 text-gold">
          Our Community
        </h2>
        <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900">
          Friends of Wattlenest
        </p>
        <p className="mt-4 text-lg text-gray-600">
          Supporters, mentors, and advocates who share our vision.
        </p>
      </div>

      {isLoading ? (
        <div className="text-center py-12">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-gold border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
          <p className="mt-4 text-gray-600">Loading friends...</p>
        </div>
      ) : friends.length === 0 ? (
        <p className="text-center py-12 text-gray-600">No friends found.</p>
      ) : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
          {friends.map((friend) => (
            <div
              key={friend.id}
              className="relative overflow-hidden rounded-lg bg-white shadow-md transition-all hover:shadow-lg"
            >
              <div className="aspect-[4/4.5] relative">
                <img
                  src={friend.imageUrl}
                  alt={friend.name}
                  className="h-full w-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      "/placeholder-image.svg";
                  }}
                />
              </div>
              <div className="p-2">
                <h3 className="text-sm font-semibold text-gray-900">
                  {friend.name}
                </h3>
                <p className="mt-1 text-xs text-gray-500">
                  {friend.relationship}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
